class Environment {

    private node_env :string | undefined = ''

    constructor() {
        this.node_env = process.env.NODE_ENV
    }

    get backendUrl(){
        if (this.isDev) {
            return "http://localhost"
        }
        return ""
    }

    get apiBackendUrl(){
        return this.backendUrl + "/api"
    }

    get isDev(){
        return this.node_env == 'development'
    }

    get googleLoginEnabled(){
        return this.isDev;
    }
}

const env = new Environment()

export default env;
